export const GET_TEAMS = "GET_TEAMS";
export const GET_TEAM_BY_ID = "GET_TEAM_BY_ID";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const CREATE_TEAM = "CREATE_TEAM";
export const GET_TEAM_USERS = "GET_TEAM_USERS";
